import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import device from './modules/device'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    device
  }
})

export default store
